/// <reference path="../DataTypes/types.js" />

import { createContext, useContext, useState, useEffect } from 'react';
import { t } from 'i18next';

import SizeType from './../DataTypes/SizeType';
import ReservationService from '../Services/ReservationService';
import SettingsService from '../Services/SettingsService';
import LocationService from '../Services/LocationService';
import DateService from '../Services/DateService';

const getLocationFromContainerParam = () => {
  const container = new URLSearchParams(window.location.search).get(
    'container'
  );
  if (!container) return null;
  const locations = LocationService.getActiveLocations();
  return (
    locations.find(loc => String(loc.page_id) === String(container)) ?? null
  );
};

const GlobalContext = createContext();
export const useGlobal = () => useContext(GlobalContext);

export const GlobalStateProvider = ({ children }) => {
  /** @type {[Room|null, Function]} */
  const [room, setRoom] = useState(null);

  /** @type {[User|null, Function]} */
  const [user, setUser] = useState(null);

  const [loading, setLoading] = useState(false);
  const [date, setDate] = useState(() => DateService.getToday());
  const [currentLocation, setCurrentLocation] = useState(() =>
    getLocationFromContainerParam()
  );

  const [sizeTypes, setSizeTypes] = useState([]);
  const [selectedSize, setSelectedSize] = useState(null);
  const [titanEmail, setTitanEmail] = useState(
    () => getLocationFromContainerParam()?.email ?? null
  );

  const pluginUrl = SettingsService.getPluginUrl();
  const [cvr, setCvr] = useState('');

  const [orderId, setOrderId] = useState(null);

  const [debtor, setDebtor] = useState(null);
  const [order, setOrder] = useState(null);

  const [sessionId] = useState(() =>
    Math.floor(Math.random() * 2147483647).toString()
  );

  const [previousRoomId, setPreviousRoomId] = useState(null);

  useEffect(() => {
    setSizeTypes(
      (currentLocation?.grouped_size_types || []).map(
        (type, index) =>
          new SizeType(
            index,
            type.title,
            type.description,
            type.sizeInSquareMeters,
            type.sizes,
            type.images || [],
            type.formSize || null,
            type.isIndoor
          )
      )
    );
  }, [currentLocation]);

  const setRoomWithReservation = async newRoom => {
    if (!newRoom || !newRoom.Id) {
      if (previousRoomId !== null) {
        await ReservationService.clearRoomReservation(
          previousRoomId,
          sessionId
        );
        setPreviousRoomId(null);
      }
      setRoom(newRoom);
      return;
    }

    // Clear previous room reservation if it exists
    if (previousRoomId !== null) {
      await ReservationService.clearRoomReservation(previousRoomId, sessionId);
    }

    // Make new room reservation
    const result = await ReservationService.makeRoomReservation(
      newRoom.Id,
      sessionId
    );

    if (result.success) {
      setPreviousRoomId(newRoom.Id);
      setRoom(newRoom);
    }
  };

  return (
    <GlobalContext.Provider
      value={{
        loading,
        setLoading,
        currentLocation,
        setCurrentLocation,
        pluginUrl,
        room,
        setRoom: setRoomWithReservation,
        user,
        setUser,
        sizeTypes,
        setSizeTypes,
        selectedSize,
        date,
        setDate,
        setSelectedSize,
        titanEmail,
        setTitanEmail,
        sessionId,
        cvr,
        setCvr,
        orderId,
        setOrderId,
        debtor,
        setDebtor,
        order,
        setOrder,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};
